import { core } from '@tock/coretypes';

/*
Hey you, utils in this file solely target flex ticketTypes fyi.
If looking for slot ticketTypes don't use this file.
*/

export const hasCreditCardHoldPriceConfig = (ticketType: {
  ticketTypePriceConfig?: core.ITicketTypePriceConfig[] | null;
}) => ticketType.ticketTypePriceConfig?.some(({ priceType }) => priceType === 'PAYMENT_CARD_HOLD');

export const hasDepositPriceConfig = (ticketType: {
  ticketTypePriceConfig: core.ITicketTypePriceConfig[];
}) => ticketType.ticketTypePriceConfig?.some(({ priceType }) => priceType === 'DEPOSIT');

export const priceConfigsHaveDepositPriceConfig = (
  ticketTypePriceConfig: core.ITicketTypePriceConfig[]
) => ticketTypePriceConfig?.some(({ priceType }) => priceType === 'DEPOSIT');

export const getCreditCardHoldPrice = (ticketType: core.ITicketType) =>
  ticketType.ticketTypePriceConfig?.find(({ priceType }) => priceType === 'PAYMENT_CARD_HOLD')
    ?.priceCents;

export const ticketTypeToNormalizedTicketTypeVariety = (ticketType: core.ITicketType) =>
  hasCreditCardHoldPriceConfig(ticketType) ? 'PAYMENT_CARD_HOLD' : ticketType.variety;

export const hasMultiTierPricing = (ticketType: core.ITicketType) =>
  (ticketType?.ticketTypePriceConfig?.length ?? 0) > 1;

export const ticketTypePriceConfigsAreMultiTierPricing = (
  ticketTypePriceConfigs: core.ITicketTypePriceConfig[]
) => ticketTypePriceConfigs?.length >= 2;

export const getTierForPartySize = (
  ticketTypePriceConfigs: core.ITicketTypePriceConfig[],
  partySize: number
) => {
  const tiers = ticketTypePriceConfigs
    ?.filter((ttpc) => ttpc.minPartySizeInclusive != null)
    .filter(({ minPartySizeInclusive }) => (minPartySizeInclusive as number) <= partySize)
    .sort((a, b) => (a.minPartySizeInclusive as number) - (b.minPartySizeInclusive as number));

  if (tiers?.length > 0) {
    return tiers[tiers.length - 1];
  }

  return undefined;
};

export const getLastTierSortedByPartySize = (
  ticketTypePriceConfigs: core.ITicketTypePriceConfig[]
) => {
  const tiers = ticketTypePriceConfigs
    ?.filter((ttpc) => ttpc.minPartySizeInclusive != null)
    .sort((a, b) => (b.minPartySizeInclusive as number) - (a.minPartySizeInclusive as number));

  if (tiers?.length > 0) {
    return tiers[0];
  }

  return undefined;
};
